// ============================================================================
// ZENTRALE KONFIGURATION – Kola Pension
// Alle unsicheren / noch nicht bestätigten Angaben werden HIER gepflegt.
// Platzhalter in eckigen Klammern [..] werden auf der Website automatisch als
// "noch nicht verfügbar" behandelt (z. B. deaktivierte Buttons).
// ============================================================================

export type Localized = { de: string; en: string };

export const siteConfig = {
  name: "Kola Pension",
  // Leer lassen => aktuelle Domain wird für Canonical/OG-URLs verwendet
  siteUrl: "",
  address: {
    street: "Junkerstraße 12",
    zip: "86343",
    city: "Königsbrunn",
    country: "Deutschland",
    countryCode: "DE",
  },
  region: "Augsburg",
  contacts: [
    { name: "Kristian Kola", phone: "0176 24458820", phoneHref: "+4917624458820", email: "Kristian.kola95@icloud.com" },
    { name: "Alfred Kola", phone: "0176 24459020", phoneHref: "+4917624459020", email: "alfred_kola09@outlook.de" },
  ],
  stats: { rooms: 8, beds: 27 },
  // Preis pro BETT und Nacht (nicht pro Zimmer!)
  price: { perBedPerNight: 20, currency: "€" },
  // Parkplätze: Anzahl erst anzeigen, wenn confirmed = true
  parking: { spaces: 20, confirmed: true },
  // Längere Aufenthalte: erst als bestätigt anzeigen, wenn true
  longStayConfirmed: false,

  // --------------------------------------------------------------------------
  // EXTERNE LINKS – hier die echten URLs eintragen
  // --------------------------------------------------------------------------
  bookingLinks: {
    bookingCom: "https://www.booking.com/hotel/de/kola-pension.de.html",
    googleMaps: "https://maps.app.goo.gl/rqj53ZNqr9NrxpoE8",
    // Google Maps Embed (iframe src) – ohne API-Key, basiert auf der Adresse
    googleMapsEmbed: "https://www.google.com/maps?q=Junkerstra%C3%9Fe%2012%2C%2086343%20K%C3%B6nigsbrunn&output=embed",
    otherPlatforms: [] as { name: string; url: string }[],
  },

  // Social Media – leer lassen => wird nicht angezeigt
  social: {
    facebook: "",
    instagram: "",
    whatsapp: "",
  },

  // --------------------------------------------------------------------------
  // RECHTLICHE ANGABEN (Impressum / Datenschutz)
  // --------------------------------------------------------------------------
  legal: {
    // Rechtsform: Gesellschaft bürgerlichen Rechts (GbR) mit zwei Gesellschaftern
    officialBusinessName: "Kola Pension GbR",
    ownerFullName: "Kristian Kola, Alfred Kola",
    businessAddress: "Junkerstraße 12, 86343 Königsbrunn, Deutschland",
    businessEmail: "Kristian.kola95@icloud.com",
    businessPhone: "0176 24458820",
    // Steuernummer / USt-IdNr wird auf Anfrage mitgeteilt (noch nicht vergeben/veröffentlicht)
    taxInformation: "Steuernummer bzw. Umsatzsteuer-Identifikationsnummer wird auf Anfrage mitgeteilt.",
    // Zuständige Datenschutz-Aufsichtsbehörde (Bayern)
    supervisoryAuthority: "Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach",
  },

  // --------------------------------------------------------------------------
  // LAGE – leer lassen => "Angaben folgen" wird angezeigt. KEINE Distanzen erfinden.
  // --------------------------------------------------------------------------
  location: {
    supermarket: "",
    restaurants: "",
    publicTransport: "",
    travelTimes: "",
    messeAugsburgDistance: "",
    augsburgCenterDistance: "",
  },
};

export const isPlaceholder = (value?: string) => !value || value.trim().startsWith("[");

export const formatPrice = () => `${siteConfig.price.perBedPerNight} ${siteConfig.price.currency}`;

export const fullAddress = () =>
  `${siteConfig.address.street}, ${siteConfig.address.zip} ${siteConfig.address.city}`;
